var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_18436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3146 12.4518C9.48511 12.4518 10.434 11.5019 10.434 10.3301C10.434 9.15838 9.48511 8.2085 8.3146 8.2085C7.14408 8.2085 6.19519 9.15838 6.19519 10.3301C6.19519 11.5019 7.14408 12.4518 8.3146 12.4518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8401 7.29169C16.7778 7.21969 16.7035 7.16208 16.6148 7.12128C16.3007 6.97488 15.8979 7.09248 15.6893 7.41649C15.6845 7.42369 15.6749 7.42609 15.6677 7.42609C12.702 6.62688 9.73628 5.83007 6.76815 5.03085C6.5308 4.96845 6.27426 4.99965 6.07047 5.13406C5.84271 5.28526 5.67728 5.50606 5.61974 5.76046C5.54541 6.08447 5.64371 6.44687 5.85949 6.66528C5.92662 6.73248 6.07047 6.87648 6.2359 6.83808C6.37735 6.80688 6.45168 6.66048 6.46846 6.62448C6.57635 6.22367 6.68663 5.81807 6.79692 5.41486C9.7195 6.18767 12.6445 6.96048 15.567 7.73329C15.3321 8.2445 15.0971 8.75571 14.8598 9.26691C14.8478 9.26931 14.8334 9.27412 14.819 9.27891C14.7591 9.30052 14.7183 9.32932 14.7135 9.33412C14.6632 9.37012 11.9899 11.0309 8.27619 13.3398C8.18508 13.4118 7.94533 13.6254 7.85183 13.9878C7.79669 14.2062 7.81347 14.391 7.83505 14.5038C8.39846 16.4862 8.96188 18.4662 9.5229 20.4487L5.15222 27.38C4.86212 27.8408 4.99878 28.4528 5.4591 28.7432C5.62214 28.8464 5.80435 28.8968 5.98416 28.8968C6.31262 28.8968 6.63149 28.7336 6.8209 28.436L11.3906 21.1855L11.4002 28.0136C11.4002 28.5584 11.8437 29 12.3879 29C12.3879 29 12.3879 29 12.3903 29C12.9346 29 13.3781 28.556 13.3757 28.0112C13.3709 25.1071 13.3685 22.2055 13.3637 19.3015C13.0784 17.9142 12.9274 17.1678 12.6421 15.7806C12.6397 15.7758 12.6421 15.7686 12.6469 15.7638C13.311 14.9118 13.9775 14.0622 14.6416 13.2126C14.6728 13.1718 14.6991 13.1286 14.7207 13.0806C15.4592 11.4005 16.1976 9.71812 16.936 8.0381C17.0439 7.78849 17.0175 7.49329 16.8401 7.29169ZM13.5363 12.2718C13.1096 12.4854 12.6828 12.7014 12.2561 12.915C12.2561 12.771 12.2561 12.6246 12.2561 12.4806C12.7955 12.1494 13.335 11.8206 13.8744 11.4893C13.7617 11.751 13.649 12.0102 13.5363 12.2718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_18436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRounds);
export default __webpack_public_path__ + "static/media/TotalRounds.3ccbe69c16a584e7343f5186c028c530.svg";
export { ForwardRef as ReactComponent };